import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { LoggerService } from '@careapp/angular-sdk';
import { AppSettings } from '../settings/app-settings.service';
var InviteComponent = /** @class */ (function () {
    function InviteComponent(fb, logger, settings) {
        this.fb = fb;
        this.logger = logger;
        this.settings = settings;
        this._disabled = false;
        this._loading = false;
        this._roleOptions = [];
        this.email = new FormControl('', Validators.compose([Validators.required, Validators.email]));
        this.role = new FormControl('', Validators.compose([Validators.required, this.validRoleType.bind(this)]));
        this.invite = new EventEmitter();
        this.form = this.createForm();
    }
    Object.defineProperty(InviteComponent.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (val) {
            this._disabled = val;
            if (this._disabled) {
                this.form.disable();
            }
            else {
                this.form.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InviteComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (val) {
            this._loading = val;
            if (this._loading && !this.form.disabled) {
                this.form.disable();
            }
            else if (!this._loading && !this._disabled && this.form.disabled) {
                this.form.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InviteComponent.prototype, "roleOptions", {
        get: function () {
            return this._roleOptions;
        },
        set: function (val) {
            this._roleOptions = val;
        },
        enumerable: true,
        configurable: true
    });
    InviteComponent.prototype.ngOnInit = function () {
        this.logger.log('in invite');
    };
    InviteComponent.prototype.createForm = function () {
        return this.fb.group({ email: this.email, role: this.role });
    };
    InviteComponent.prototype.submit = function (form) {
        this.logger.log('emit invitation');
        if (this.form.invalid)
            return false;
        if (this.loading)
            return false;
        if (this.disabled)
            return false;
        this.invite.emit(form);
        this.form.reset();
        return false;
    };
    InviteComponent.prototype.validRoleType = function (control) {
        if (this.roleOptions.includes(control.value)) {
            return null;
        }
        return { invalidRoleType: true };
    };
    return InviteComponent;
}());
export { InviteComponent };
